// ** React Imports
import { useContext } from 'react'

//**Next Import
import Link from 'next/link'

//** MUI Import
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Typography from '@mui/material/Typography'

import TimeAgo from 'javascript-time-ago'
import id from 'javascript-time-ago/locale/id'

// ** Icons Imports
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded'
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded'

// ** Context
import { AuthContext } from 'src/context/AuthContext'

import { RekrutmenList } from 'src/types/rekrutmen-list'

const CustomYellowCard = ({ data }: { data: RekrutmenList }) => {
  TimeAgo.addDefaultLocale(id)
  const timeAgo = new TimeAgo('id-ID')

  const { user } = useContext(AuthContext)

  return (
    <Box sx={{ px: 3, py: 4 }}>
      <Link href={`${user ? '/pelamar/rekrutmen/' : '/rekrutmen/'}${data.id}`}>
        <Box
          sx={{
            py: 8,
            px: 4,
            display: 'flex',
            minHeight: 200,
            alignItems: 'center',
            backgroundColor: theme => theme.myColor?.lightYellow,
            borderRadius: 1,
            cursor: 'pointer',
            ':hover': {
              outline: theme => `2px solid ${theme.palette.primary.main}`
            }
          }}
        >
          <Typography variant='h4' color='primary' sx={{ fontWeight: 600, height: 'fit-content' }}>
            {data.judul}
          </Typography>
        </Box>
      </Link>
      <Link href={`${user ? '/pelamar/rekrutmen/' : '/rekrutmen/'}${data.id}`}>
        <Typography
          variant='h6'
          color='primary'
          sx={{ fontWeight: 600, my: 2, cursor: 'pointer', ':hover': { textDecoration: 'underline' } }}
        >
          {data.sub_judul}
        </Typography>
      </Link>
      {/* <Typography variant='body1'>dibuat oleh Human Capital Bankaltimtara</Typography> */}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <VisibilityRoundedIcon sx={{ fontSize: '1rem', mr: 1 }} />
        <Typography variant='body2'>{`${data.jumlah_dilihat.toLocaleString()} kali dilihat.`}</Typography>
        <AccessTimeRoundedIcon sx={{ fontSize: '1rem', mr: 1, ml: 2 }} />
        <Typography variant='body2'>{`${timeAgo.format(new Date(data.created_at))}.`}</Typography>
      </Box>
      <Chip
        label={data.rekrutmenklasifikasi.rekrutmen_klasifikasi}
        color='primary'
        variant='outlined'
        sx={{
          my: 4,
          px: 4,
          backgroundColor: theme => theme.myColor?.lightBlueBg,
          borderWidth: 0
        }}
      />
    </Box>
  )
}

export default CustomYellowCard
